import { render } from "./ButtonFullWidth.vue?vue&type=template&id=4b681490&scoped=true"
import script from "./ButtonFullWidth.vue?vue&type=script&lang=js"
export * from "./ButtonFullWidth.vue?vue&type=script&lang=js"

import "./ButtonFullWidth.vue?vue&type=style&index=0&id=4b681490&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b681490"]])

export default __exports__